import axios from 'axios';

import apiUrls from '../../../public/assets/exports.json';

import { AppConfig } from '.';

let exportsCache: AppConfig;

const getExports = async (): Promise<AppConfig> => {
  const env = process.env.NODE_ENV;

  if (env === 'development') return apiUrls as unknown as AppConfig;

  try {
    if (exportsCache == null) {
      const { data } = await axios.get('/new-provider/assets/exports.json');
      exportsCache = { ...(data as AppConfig) };
    }

    return exportsCache;
  } catch (e) {
    return {} as AppConfig;
  }
};

export { getExports };
